// What a Football Operations user may see, set per user by admins (Users →
// Manage roles) and stored on users/{uid}.footballOpsPermissions. Like the
// supplier permissions, but a missing key means ALLOWED, so accounts created
// before these existed keep seeing everything.
//
// `enforced` permissions are also checked by firestore.rules (see foCan /
// foTourPathOK). The other two live on the tour document itself, which the
// portal needs to list tours, so they can only be hidden on screen.

export const FOOTBALL_OPS_PERMISSIONS = [
  { key: 'overview',        label: 'Tour overview',                       hint: 'Hotel, numbers, flights, tour leaders', enforced: false },
  { key: 'groupContact',    label: 'Group contact details',               hint: 'Name, phone and email',                 enforced: false },
  { key: 'fixtures',        label: 'Fixtures',                            hint: 'Matches for each team',                 enforced: true },
  { key: 'fixtureContacts', label: 'Opposition coach & referee contacts', hint: 'On fixtures and the itinerary',         enforced: true },
  { key: 'teamInfo',        label: 'Team information',                    hint: 'Squads, ages and kits',                 enforced: true },
  { key: 'teams',           label: 'Team lists',                          hint: 'Which players are in each team',        enforced: true },
  { key: 'itinerary',       label: 'Full itinerary',                      hint: '',                                      enforced: true },
  { key: 'skeleton',        label: 'Skeleton itinerary',                  hint: '',                                      enforced: true },
  { key: 'notes',           label: 'Tour notes',                          hint: 'Staff notes pinned to the tour',        enforced: true },
];

export const DEFAULT_FOOTBALL_OPS_PERMISSIONS = Object.fromEntries(
  FOOTBALL_OPS_PERMISSIONS.map((p) => [p.key, true])
);

/** Stored permissions with every missing key filled in as allowed. */
export function withFootballOpsDefaults(stored) {
  const out = { ...DEFAULT_FOOTBALL_OPS_PERMISSIONS };
  for (const { key } of FOOTBALL_OPS_PERMISSIONS) {
    if (stored && stored[key] === false) out[key] = false;
  }
  return out;
}

/**
 * The permissions that apply to a user. They only restrict accounts whose
 * sole role is football_ops; anyone who also holds another role (or is an
 * admin) sees everything, matching the rules.
 */
export function effectiveFootballOpsPermissions(roles, stored) {
  const onlyFootballOps = (roles || []).length > 0 && roles.every((r) => r === 'football_ops');
  return onlyFootballOps ? withFootballOpsDefaults(stored) : { ...DEFAULT_FOOTBALL_OPS_PERMISSIONS };
}
